import { UI } from "../../core/ui";

export const runOnceNotification = (error: string, maxWidth = 768) => {
    var gnContainer = document.getElementById('gn-container');
    if(gnContainer && gnContainer?.children.length < 1  && error) {
        UI.notification.error(error, { timeout: 2000});
    }
}
